export default "__VITE_ASSET__BG$cM6Oy__"